import axios from 'axios';
import BaseAPI from './base/base-api';

class ResourceAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'resource';
}

export default new ResourceAPI();